import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { statTypes } from "../shared/components/Table/utils";

export const StatsContext = createContext();
StatsContext.displayName = 'Stats';

export function useHash() {
  const [hash, setHash] = useState(() => window.location.hash);

  const hashChangeHandler = useCallback(() => {
    setHash(window.location.hash);
  }, []);

  useEffect(() => {
    window.addEventListener('hashchange', hashChangeHandler);
    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, []);

  const updateHash = useCallback(
    newHash => {
      if (newHash !== hash) window.location.hash = newHash;
    },
    [hash]
  );

  return [hash, updateHash];
}

export const getStatTypeQuery = (statType) => {
  if (!statType) return null;

  switch (statType) {
    case statTypes.statsGeneral:
      return "general";
    case statTypes.statsPassing:
      return "passing";
    case statTypes.statsDefending:
      return "defending";
    case statTypes.statsAttacking:
      return "attacking";
    case statTypes.statsGoalKeeping:
      return "goalkeeping";
    default:
      return statType;
  }
};

export const getStatTypeFromQuery = (statType) => {
  if (!statType) return null;

  switch (statType) {
    case "general":
      return statTypes.statsGeneral;
    case "passing":
      return statTypes.statsPassing;
    case "defending":
      return statTypes.statsDefending;
    case "attacking":
      return statTypes.statsAttacking;
    case "goalkeeping":
      return statTypes.statsGoalKeeping;
    default:
      return statType;
  }
};

export const getHashQueryObject = (query) => {
  const pairs = query.slice(1).split("&");
  const filters = {};
  pairs.forEach(function (pair) {
    pair = pair.split('=');
    filters[pair[0]] = decodeURIComponent(pair[1] || '');
  });

  return filters;
};

export function useStatsData() {
  const context = useContext(StatsContext);
  if (context === undefined) {
    throw new Error('useStatsData must be used within a <PlayerStats /> or <ClubStats/>');
  }
  return context;
}
